var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PIC_AppStack;
import { iDBHandler } from '../indexedDB/iDBHandler';
import { GlobSysInfo, GlobEvents, GlobStorage, GlobError, GlobUserConfig, PICModal, Util, webmenu, PICWebSocketClient, fetchApiData, exportFetchURL, exportFetchHeaders, PICNotificationManager } from '../templates/Internals';
import { setupMSAL } from './auth/SSO';
Date.prototype.getWeek = function () {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};
String.prototype.trimCharStart = function (iChar) {
    return this.replace(new RegExp('^' + (iChar !== null && iChar !== void 0 ? iChar : '') + '+', 'gim'), '');
};
String.prototype.trimCharEnd = function (iChar) {
    return this.replace(new RegExp(((iChar !== null && iChar !== void 0 ? iChar : '') + '+$'), 'g'), '');
};
export class PIC {
    get error() { return this.error_; }
    get sysinfo() { return this.sysinfo_; }
    get events() { return this.events_; }
    get storage() { return this.storage_; }
    get picInputs() { return this.inputs; }
    get userConfig() { return this.userConfig_; }
    get picSubmitButton() { return this.submitButton; }
    get sessionCode() { return this.sysinfo.sessionCode; }
    get user() { return this.sysinfo.user; }
    get moduleId() { return this.sysinfo.moduleId; }
    get eventid() { return this.sysinfo.eventid; }
    get systemId() { return this.sysinfo.systemId; }
    get subwin() { return this.sysinfo.subwin; }
    get program() { return this.sysinfo.program; }
    get datemode() { return this.sysinfo.datemode; }
    get listeners() { return this.events.listeners; }
    get debug() { return (window.PIC && window.PIC.getDebug()) == true; }
    get isTeamTools() { return this.sysinfo.isTeamTools; }
    get webVersion() { return this.sysinfo.webVersion; }
    get appVersion() { return this.sysinfo.appVersion; }
    //@ts-ignore
    get isMobileOrTablet() { let check = false; (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
        check = true; })(navigator.userAgent || navigator.vendor || window.opera); return check; }
    get msal() {
        return this.msal_;
    }
    static get sessionCode() { return GlobSysInfo.sessionCode; }
    static get user() { return GlobSysInfo.user; }
    static get moduleId() { return GlobSysInfo.moduleId; }
    static get eventid() { return GlobSysInfo.eventid; }
    static get systemId() { return GlobSysInfo.systemId; }
    static get subwin() { return GlobSysInfo.subwin; }
    static get program() { return GlobSysInfo.program; }
    static get datemode() { return GlobSysInfo.datemode; }
    static get WebWersion() { return GlobSysInfo.webVersion; }
    static get appVersion() { return GlobSysInfo.appVersion; }
    static get isTeamTools() { return GlobSysInfo.isTeamTools; }
    static get debug() { return (window.PIC && window.PIC.getDebug()) == true; }
    static get trace() { return (window.PIC && window.PIC.getTrace()) == true; }
    static get getInstance() {
        if (!window.PIC) {
            window.PICWebSocketClient = PICWebSocketClient;
            window.PIC = new PIC();
            if (window.PIC.events)
                window.PIC.events.setGlobalListeners();
        }
        return window.PIC;
    }
    static msg(iTxt, ...optionalParams) { if (PIC.debug) {
        console.log(iTxt, ...optionalParams);
        if (PIC.trace)
            console.trace();
    } }
    addToStack(iObj, updateLast) {
        if (updateLast) {
            __classPrivateFieldGet(this, _PIC_AppStack, "f").push(Object.assign(Object.assign({}, __classPrivateFieldGet(this, _PIC_AppStack, "f").pop()), iObj));
        }
        else {
            __classPrivateFieldGet(this, _PIC_AppStack, "f").push(iObj);
        }
    }
    //@ts-ignore
    get platform() { var _a, _b; return (_b = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform) !== null && _b !== void 0 ? _b : navigator.platform; }
    get isMac() {
        var _a, _b;
        //@ts-ignore userAgentData not found on Navigator, only available in https context and chrome/edge/opera
        let platformStr = (_b = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform) !== null && _b !== void 0 ? _b : navigator.platform;
        return platformStr.toUpperCase().indexOf('MAC') >= 0;
    }
    get browser() {
        var _a;
        if ('userAgentData' in window.navigator) {
            //@ts-ignore until navigator type file gets updated
            let brands = navigator.userAgentData.brands;
            if (brands.length > 2)
                return (_a = brands[2]) === null || _a === void 0 ? void 0 : _a.brand;
            for (let brand of brands) {
                if (brand.brand === 'Microsoft Edge') {
                    return 'Microsoft Edge';
                }
                if (brand.brand === 'Google Chrome') {
                    return 'Google Chrome';
                }
            }
        }
        else if (window.navigator.userAgent.includes('Firefox')) {
            return 'Mozilla Firefox';
        }
        else {
            //pull from userAgent
            return '';
        }
    }
    constructor() {
        this.submitButton = null;
        this.timeouts = [];
        this.intervals = [];
        this.ctrlKeyIsDown = false;
        this.openNewWindow = false;
        this.API = {
            exportFetchURL: exportFetchURL,
            exportFetchHeaders: exportFetchHeaders,
            fetchApiData: fetchApiData
        };
        this.fromProgress = true;
        this.isLocalClient = false;
        _PIC_AppStack.set(this, []);
        this.PICWinMap = new Map();
        if (sessionStorage.getItem("overrideConsoleLog") && sessionStorage.getItem("overrideConsoleLog") === 'true')
            Util.overrideConsoleLog();
        Util.setLogFunctions();
        this.error_ = new GlobError();
        this.sysinfo_ = new GlobSysInfo();
        this.events_ = new GlobEvents();
        this.storage_ = new GlobStorage();
        this.userConfig_ = new GlobUserConfig();
        this.notificationManager_ = new PICNotificationManager();
        this.inputs = new Map();
        this.webmenu = webmenu;
        if (typeof this.msal_ === 'undefined') {
            setupMSAL().then(msalInstance => {
                this.msal_ = msalInstance;
            });
        }
        if (typeof window.addEventOnce == 'undefined') {
            window.addEventOnce = this.addEventOnce;
        }
        if (this.PICWinMap.size === 0) {
            window.addEventListener('DOMContentLoaded', () => {
                this.PICWinMap.set(this.sessionCode, document.documentElement);
            });
        }
        dispatchEvent(new Event('PICloaded'));
    }
    IDBsetup() { this.pIDB = new iDBHandler('/rnd/indexedDB/idb.config.json'); }
    msg(iTxt, ...optionalParams) { if (PIC.debug)
        console.log(iTxt, ...optionalParams); if (PIC.trace)
        console.trace(); }
    addInput(id, el) {
        if (this.inputs.has(id)) {
            return false;
        }
        return this.inputs.set(id, el);
    }
    removeInput(id) {
        this.inputs.delete(id);
    }
    clearInputs() {
        this.inputs = new Map();
        ;
    }
    setSubmitButton(iPicButton) {
        if (iPicButton == null)
            this.submitButton = null;
        else if (!this.submitButton || !this.submitButton.isConnected)
            this.submitButton = iPicButton;
    }
    /* Use to make old non-custom inputfields compatible with loadpage. */
    firstSubmit(iElement, iEvent) {
        let firstSubmit;
        // in modal web3
        if (iElement.getRootNode().firstElementChild instanceof PICModal) {
            if (iElement.getRootNode().firstElementChild.submitButton) {
                firstSubmit = iElement.getRootNode().firstElementChild.submitButton;
                if (firstSubmit) {
                    firstSubmit.doEvent(iEvent);
                    return;
                }
                ;
            }
            ;
            // in modal web2
        }
        else if (iElement.getRootNode().firstElementChild.dom) {
            firstSubmit = iElement.getRootNode().firstElementChild.dom.shadowRoot.querySelector('input[type=submit]');
            if (firstSubmit) {
                firstSubmit.click();
                return;
            }
            // in lightDom regular button
        }
        else if (document.querySelector('input[type=submit]')) {
            firstSubmit = document.querySelector('input[type=submit]');
            if (firstSubmit) {
                firstSubmit.click();
                return;
            }
            ;
            // in lightDom PICButton
        }
        else if (PIC.getInstance.picSubmitButton) {
            firstSubmit = PIC.getInstance.picSubmitButton;
            if (firstSubmit) {
                firstSubmit.doEvent(iEvent);
                return;
            }
            ;
        }
        ;
    }
    ;
    /* notifications */
    getNotificationManager() { return this.notificationManager_; }
    ;
    startNotificationChannel(iChannelId) { this.notificationManager_.addChannel(iChannelId); }
    ;
    startNotificationAPI(iChannelId, refreshTimer) { this.notificationManager_.addAPI(iChannelId, { apiRefreshTimer: refreshTimer }); }
    ;
    addNotificationConsumer(iConsumer) { this.notificationManager_.addConsumer(iConsumer); }
    ;
    removeNotificationConsumer(iConsumer) { this.notificationManager_.removeConsumer(iConsumer); }
    ;
    getUnseenNotificationCount() { return this.notificationManager_.unseenNotificationCount; }
    ;
    getNotificationCount() { return this.notificationManager_.notificationCount; }
    ;
    getNotificationPriorityCount() { return this.notificationManager_.notificationPriorityCount; }
    ;
    getNotifications() { return this.notificationManager_.allNotifications; }
    ;
    getFilteredNotifications(iOpt) { return this.notificationManager_.getFilteredNotifications(iOpt); }
    ;
    removeNotification(iChannelId, iNotification) { return this.notificationManager_.removeNotification(iChannelId, iNotification); }
    ;
    updateNotification(iChannelId, iNotification) { return this.notificationManager_.updateNotification(iChannelId, iNotification); }
    ;
    getDebug() { return this.storage.getDebug(); }
    setDebug(debug = true, trace = false) { this.storage.setDebug(debug); this.storage.setTrace(trace); }
    getTrace() { return this.storage.getTrace(); }
    addEventListener(eventType, eventFunction, iOption) { return this.events.addEventListener(eventType, eventFunction, iOption); }
    removeEventListener(eventType, eventFunction) { this.events.removeEventListener(eventType, eventFunction); }
    addEventOnce(eventType, eventFunction, iOption) {
        if (typeof this.events === 'undefined') {
            throw new Error('this.events is undefined for: <' + eventType + '> ' + eventFunction);
        }
        this.events.addEventOnce(eventType, eventFunction, iOption);
    }
    clearEventListeners() { this.events.clearEventListeners(); }
    clearSubEvents() { }
    setTimeout(eventFunction, timeout) {
        this.timeouts.push(window.setTimeout(eventFunction, timeout));
        return this.timeouts.length - 1;
    }
    clearTimeouts() {
        this.timeouts.forEach((timeout, idx) => {
            if (typeof timeout !== 'number')
                return;
            window.clearTimeout(timeout);
            this.timeouts[idx] = -1;
        });
        this.timeouts = this.timeouts.filter(timeout => timeout !== -1);
    }
    clearIntervals() {
        this.intervals.forEach((interval, idx) => {
            if (typeof interval !== 'number')
                return;
            window.clearInterval(interval);
            this.intervals[idx] = -1;
        });
        this.intervals = this.intervals.filter(interval => interval !== -1);
    }
    setInterval(eventFunction, timeout) {
        this.intervals.push(window.setInterval(eventFunction, timeout));
        return this.intervals.length - 1;
    }
    findElementByIdDeep(id, rootNode) {
        if (!id)
            return undefined;
        let allNodes = [];
        if (rootNode) {
            if (rootNode.shadowRoot)
                this.findNodes(Array.from(rootNode.shadowRoot.querySelectorAll('*')), allNodes);
            else
                this.findNodes(Array.from(rootNode.querySelectorAll('*')), allNodes);
        }
        else
            this.findNodes(Array.from(document.documentElement.querySelectorAll('*')), allNodes);
        for (let i = 0; i < allNodes.length; i++) {
            let curNode = allNodes[i];
            if (curNode.id === id)
                return curNode;
        }
    }
    findElementsByNameDeep(name) {
        let allNodes = [];
        let resNodes = [];
        this.findNodes(Array.from(document.documentElement.querySelectorAll('*')), allNodes);
        for (let i = 0; i < allNodes.length; i++) {
            let curNode = allNodes[i];
            //@ts-ignore
            if (curNode.name) {
                //@ts-ignore
                if (curNode.name === name)
                    resNodes.push(curNode);
            }
        }
        return resNodes;
    }
    findElementsByTagDeep(name) {
        let allNodes = [];
        let resNodes = [];
        this.findNodes(Array.from(document.documentElement.querySelectorAll('*')), allNodes);
        for (let i = 0; i < allNodes.length; i++) {
            let curNode = allNodes[i];
            //@ts-ignore
            if (curNode.nodeName) {
                //@ts-ignore
                if (curNode.nodeName === name)
                    resNodes.push(curNode);
            }
        }
        return resNodes;
    }
    findNodes(nodes, allNodes) {
        for (let i = 0; i < nodes.length; i++) {
            let curNode = nodes[i];
            allNodes.push(curNode);
            if (curNode.shadowRoot)
                this.findNodes(Array.from(curNode.shadowRoot.querySelectorAll('*')), allNodes);
        }
    }
    getHiddenFields() {
        let response = {};
        if (document) {
            let hiddenLst = ['moduleId', 'eventid', 'SessionCode', 'SystemId', 'Subwin'];
            hiddenLst.forEach(x => {
                let curObj = document.querySelector(`input[type=hidden][name=${x}]`);
                if (curObj)
                    response = Object.assign(Object.assign({}, response), { [x]: curObj.value });
            });
        }
        return response;
    }
    mailAppStackDecider() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // if sessionstorage has mailAppStackOnLogout === true
        if (sessionStorage.getItem("mailAppStackOnLogout")) {
            let durationDiff = Number(sessionStorage.getItem("mailAppStackOnLogout"));
            let prevStack = __classPrivateFieldGet(this, _PIC_AppStack, "f").length > 1 ? __classPrivateFieldGet(this, _PIC_AppStack, "f")[__classPrivateFieldGet(this, _PIC_AppStack, "f").length - 2] : undefined;
            let curStack = __classPrivateFieldGet(this, _PIC_AppStack, "f").length > 0 ? __classPrivateFieldGet(this, _PIC_AppStack, "f")[__classPrivateFieldGet(this, _PIC_AppStack, "f").length - 1] : undefined;
            // if request sessionCode is a picit_ user
            if ((_b = (_a = curStack === null || curStack === void 0 ? void 0 : curStack.request) === null || _a === void 0 ? void 0 : _a.SessionCode) === null || _b === void 0 ? void 0 : _b.includes('picit_')) {
                // if request eventId != Exit#none
                if (!((_d = (_c = curStack === null || curStack === void 0 ? void 0 : curStack.request) === null || _c === void 0 ? void 0 : _c.eventid) === null || _d === void 0 ? void 0 : _d.toLowerCase().startsWith('Exit'))) {
                    // if response moduleId is util/login
                    if (((_f = (_e = curStack === null || curStack === void 0 ? void 0 : curStack.response) === null || _e === void 0 ? void 0 : _e.Subwin) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === 'util/logon') {
                        // if timestamp is a while ago, adjustable from database
                        if (prevStack && curStack && durationDiff) {
                            let from = (_g = prevStack.timestamp) === null || _g === void 0 ? void 0 : _g.valueOf();
                            let to = (_h = curStack.timestamp) === null || _h === void 0 ? void 0 : _h.valueOf();
                            if (from && to) {
                                // uses minutes
                                let diff = (to - from) * (1 / (60000));
                                if (diff >= durationDiff)
                                    this.error.sendAppStack(__classPrivateFieldGet(this, _PIC_AppStack, "f"));
                            }
                        }
                    }
                }
            }
        }
    }
    //TODO: remove this after test phase
    testMailAppStack() {
        this.error.sendAppStack(__classPrivateFieldGet(this, _PIC_AppStack, "f"));
    }
}
_PIC_AppStack = new WeakMap();
PIC.consoleLog = [];
if (window) {
    PIC.getInstance;
}
//# sourceMappingURL=PIC.js.map